import Image from 'next/image';
import Link from 'next/link';
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger } from '@/components/ui/navigation-menu';
import { useNoListingMessageStore } from '@/features/listing/hooks/use-no-listing-message-store';
import { Category, useNavigation } from '@/hooks/use-navigation';
import { cn } from '@/lib/cn';
export const ShopNavigation = () => {
  const {
    categories
  } = useNavigation();
  return <div className="border-b hidden lg:block lg:h-shop-header border-gray-200 lg:px-3" data-sentry-component="ShopNavigation" data-sentry-source-file="shop-navigation.tsx">
      <NavigationMenu data-sentry-element="NavigationMenu" data-sentry-source-file="shop-navigation.tsx">
        <NavigationMenuList data-sentry-element="NavigationMenuList" data-sentry-source-file="shop-navigation.tsx">
          {categories.map(category => <NavigationItem key={category.id} category={category} />)}
        </NavigationMenuList>
      </NavigationMenu>
    </div>;
};
const NavigationItem = ({
  category
}: {
  category: Category;
}) => {
  const setLastListingCategory = useNoListingMessageStore(store => store.setLastListingCategory);
  return <NavigationMenuItem data-sentry-element="NavigationMenuItem" data-sentry-component="NavigationItem" data-sentry-source-file="shop-navigation.tsx">
      <NavigationMenuTrigger data-sentry-element="NavigationMenuTrigger" data-sentry-source-file="shop-navigation.tsx">{category.name}</NavigationMenuTrigger>
      <NavigationMenuContent data-sentry-element="NavigationMenuContent" data-sentry-source-file="shop-navigation.tsx">
        <div className="relative w-screen">
          <div className="mx-auto px-10">
            <div className="grid grid-cols-2 gap-x-8 gap-y-10 py-6">
              <div className="col-start-2 grid grid-cols-2 gap-x-8">
                {category.featured?.map(item => <div key={item.href} className="group relative text-base sm:text-sm">
                    <NavigationMenuLink href={item.href}>
                      <div className="relative aspect-h-1 aspect-w-1 overflow-hidden bg-gray-100 group-hover:opacity-75">
                        <Image src={item.imageSrc} alt={item.imageAlt} fill className={cn('object-cover w-full h-full', item.name === 'New' && category.id === 'mens' ? 'object-center' : 'object-top', item.className)} priority />
                      </div>
                    </NavigationMenuLink>
                    <NavigationMenuLink asChild>
                      <Link href={item.href} className="mt-6 block font-medium text-gray-900">
                        {item.name}
                      </Link>
                    </NavigationMenuLink>
                    <p aria-hidden="true" className="mt-1">
                      Shop now
                    </p>
                  </div>)}
              </div>
              <div className="row-start-1 grid grid-cols-2 gap-x-8 gap-y-10 text-md">
                {category.sections?.map(section => <div key={section.id}>
                    <p id={`${section.name}-heading`} className="font-bold text-gray-900 text-lg">
                      {section.name}
                    </p>
                    <ul role="list" aria-labelledby={`${section.name}-heading`} className="mt-6 sm:mt-4">
                      {section.items.map(item => {
                    const slug = `?${section.id}=${item.href}`;
                    const href = item.name === 'Browse All' ? `/search/${category.id}` : `/search/${category.id}${slug}`;
                    return <li key={item.name} className="flex border-b last:border-b-0 hover:bg-gray-200 -ml-3 last:font-bold">
                            <NavigationMenuLink asChild>
                              <Link onClick={() => setLastListingCategory(null)} href={href} className="hover:text-gray-800 text-gray-900 w-full p-3 text-sm">
                                {item.name}
                              </Link>
                            </NavigationMenuLink>
                          </li>;
                  })}
                    </ul>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </NavigationMenuContent>
    </NavigationMenuItem>;
};